// RasPm Dashboard Base Styles
import { Label } from "@mui/icons-material";
import { Select } from "@mui/material";
import colors from "assets/theme/base/colors";
import { line } from "stylis";

const { info, dark } = colors;

const globals = {
  html: {
    scrollBehavior: "smooth",
  },
  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },
  body: {
    fontFamily: '"Cairo", "Roboto", "Helvetica", "Arial", sans-serif',
  },
  "input, select, textarea": {
    fontFamily: '"Cairo", "Roboto", "Helvetica", "Arial", sans-serif',
    direction: "rtl",
  },
  ".MuiInputBase-input": {
    direction: "rtl !important",
    textAlign:"left"
  },
  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },
  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 150ms ease-in !important",
  },
  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${info.main} !important`,
  },
  Label: {
    lineHeight: "1.5 !important",
  },
  Select: {
    height: "45px !important",
    "& .MuiSelect-select": {
      paddingTop: "10px !important",
      paddingBottom: "10px !important",
    },
  },
  ".MuiSelect-select": {
    paddingTop: "10px !important",
    paddingBottom: "10px !important",
  },
};

export default globals;
